import { registerLocaleData } from '@angular/common';
import localeEnGb from '@angular/common/locales/en-GB';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localePt from '@angular/common/locales/pt';
import localeNb from '@angular/common/locales/nb';
import { enGB, enUS, es, nb, pt } from 'date-fns/locale';
import { toLower } from 'lodash';

import { LocaleConfig } from './localization.model';

export const supportedLocaleData = new Map<string, LocaleConfig>([
  [
    'en-gb',
    {
      id: 'en-gb',
      description: $localize`English (UK)`,
      angularLocale: localeEnGb,
      dateFnsLocale: enGB,
      freshdeskLocale: 'en',
      datePlaceholder: 'DD/MM/YYYY',
      dateMask: '00/00/0000',
    },
  ],
  [
    'en-us',
    {
      id: 'en-us',
      description: $localize`English (US)`,
      angularLocale: localeEn,
      dateFnsLocale: enUS,
      freshdeskLocale: 'en',
      datePlaceholder: 'DD/MM/YYYY',
      dateMask: '00/00/0000',
    },
  ],
  [
    'es',
    {
      id: 'es',
      description: $localize`Spanish`,
      angularLocale: localeEs,
      dateFnsLocale: es,
      freshdeskLocale: 'es-LA',
      datePlaceholder: 'DD/MM/YYYY',
      dateMask: '00/00/0000',
    },
  ],
  [
    'pt',
    {
      id: 'pt',
      description: $localize`Portuguese`,
      angularLocale: localePt,
      dateFnsLocale: pt,
      freshdeskLocale: 'pt-BR',
      datePlaceholder: 'DD/MM/YYYY',
      dateMask: '00/00/0000',
    },
  ],
  [
    'nb',
    {
      id: 'nb',
      description: $localize`Norwegian`,
      angularLocale: localeNb,
      dateFnsLocale: nb,
      freshdeskLocale: 'nb-NO',
      datePlaceholder: 'DD.MM.YYYY',
      dateMask: '00.00.0000',
    },
  ],
]);

export const defaultLocale = supportedLocaleData.get('en-gb') as LocaleConfig;

export function registerSupportedLocaleData() {
  supportedLocaleData.forEach((locale, localeId) => {
    registerLocaleData(locale.angularLocale, localeId);
  });
}

export function getLocaleConfig(localeId: string): LocaleConfig {
  return supportedLocaleData.get(toLower(localeId)) || defaultLocale;
}

export function getPreferredLocaleId() {
  const htmlEl = document.querySelector('html') as HTMLElement;
  return htmlEl.getAttribute('lang') || navigator.language;
}

export const SUPPORTED_LOCALES = Array.from(supportedLocaleData.entries()).map(
  ([localeId, localeConfig]) => ({
    code: localeId,
    description: localeConfig.description,
  })
);
